import { MutationTree } from "vuex";
import { ForexDraftState } from "@/feature/Forex/store/draft/interface";
import { ForexDraftMutation } from "@/feature/Forex/store/draft/constants";
import { ForexBuyDraft } from "@/feature/Forex/api/form/forex-form.interface";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";
import { ForexCurrency } from "@/feature/Forex/store/interface";

export default <MutationTree<ForexDraftState>> {

	[ForexDraftMutation.addDraftList](state, list: ForexBuyDraft[]) {
		state.list.push(...list);
	},

	[ForexDraftMutation.setNextPage](state) {
		state.pageNumber++;
	},

	[ForexDraftMutation.resetPage](state) {
		state.pageNumber = 1;
		state.isEndPage = false;
		state.list = [];
	},

	[ForexDraftMutation.resetFilter](state) {
		state.dateFrom = '';
		state.dateTo = '';
		state.currency = null;
		state.operationType = null;
	},

	[ForexDraftMutation.setIsEndPage](state, isEndPage: boolean) {
		state.isEndPage = isEndPage;
	},

	[ForexDraftMutation.setDraftLoading](state, loading: boolean) {
		state.loadingCount += loading ? 1 : (state.loadingCount && -1);
	},

	[ForexDraftMutation.setOperationType](state, operationType: ForexOperationType | null) {
		state.operationType = operationType;
	},

	[ForexDraftMutation.setCurrency](state, currency: ForexCurrency | null) {
		state.currency = currency;
	},

	[ForexDraftMutation.setDateFrom](state, dateFrom: string) {
		state.dateFrom = dateFrom;
	},

	[ForexDraftMutation.setDateTo](state, dateTo: string) {
		state.dateTo = dateTo;
	},

	[ForexDraftMutation.deleteDraft](state, draftId: number) {
		const index = state.list.findIndex(draft => draft.foreignExchangeId === draftId);

		index > -1 && state.list.splice(index, 1);
	},

}